import styled from "styled-components";
import { SearchBarBox } from "../../molecules/SearchBar/SearchBar.style";

export const DBBackupSection = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const DBBackupSet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${SearchBarBox} {
    margin-bottom: 10px;
  }

  & + div {
    padding-left: 20px;
    border-left: 1px solid ${(props) => props.theme.colors.black12};
  }
`;

export const DBText = styled.div`
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
`;

export const DBButtonRow = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
`;
